import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { useNavigate } from 'react-router-dom';

export type RemoveMembershipFormProps = {
  personId: string;
  projectId: string;
  handleClose: () => void;
};

export const FC = (props: RemoveMembershipFormProps) => {
  const navigate = useNavigate();
  const [
    fnRemoveMembershipForm,
    { loading }
  ] = ds.useRemoveMembership();
  const form = ds.useFormState(props.personId, props.projectId);
  const handleSubmit = async (id: string) => {

    await fnRemoveMembershipForm(id);
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState.id);
        navigate('..');
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <></>
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
